<template>
  <div>
    <v-navigation-drawer color="#031b41" v-model="drawer" absolute temporary :class="`tw-block ${$route.name == 'Play'  ? '' : 'sm:tw-hidden'}  tw-text-left `">
      <div class="tw-py-2 tw-px-2">
        <v-btn icon @click="drawer = false">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item class="my-2" link to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="my-2" link to="/slots">
            <v-list-item-icon>
              <v-icon>mdi-slot-machine</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Slots</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="my-2" link to="/live-casino">
            <v-list-item-icon>
              <v-icon>mdi-dice-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Live Casino</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="my-2" link to="/favorites">
            <v-list-item-icon>
              <v-icon>mdi-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Favorites</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="my-2" link to="/recent-games">
            <v-list-item-icon>
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Recently Played</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="my-2" link to="/flipmaster" v-if="isFlipmasterAllowed">
            <v-list-item-icon>
              <v-icon>mdi-dice-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Flipmaster</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="my-2" @click.prevent="gotoEsports()">
            <v-list-item-icon>
              <v-icon>mdi-controller-classic</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Community Betting</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div class="tw-header tw-space-x-10  tw-w-full md:tw-w-[92%] tw-mx-auto tw-px-4">
      <div class="tw-text-white tw-text-2xl tw-flex tw-items-center tw-justify-center sm:tw-justify-start">
        <v-row :class="`tw-block ${$route.name == 'Play'  ? 'tw-mr-4' : 'sm:tw-hidden'}`" v-resize="onResize">
          <v-btn @click.stop="drawer = !drawer" large icon color="#1C1C1C" dark>
            <v-icon color="white">mdi-menu</v-icon>
          </v-btn>
        </v-row>
        <router-link to="/" class="tw-text-2xl tw-font-bold sm:tw-block tw-hidden">
          <v-img width="250" :src="require('@/assets/images/Casino2ez.png')"></v-img>
        </router-link>
      </div>
      <div class="tw-block sm:tw-hidden">
        <router-link to="/" class="tw-text-2xl tw-font-bold">
          <v-img width="150" :src="require('@/assets/images/Casino2ez.png')"></v-img>
        </router-link>
      </div>
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex-1 tw-flex tw-justify-end">
          <AuthLogin />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthLogin from "./Auth/AuthLogin.vue";

import numeral from "numeral";
import { mapState } from "vuex";
export default {
  props: ["isMaintenance"],
  components: {
    AuthLogin,
  },
  computed: {
    ...mapState("game", ["playGame", "flipmasterSettings"]),
    isFlipmasterAllowed() {
      if (this.flipmasterSettings.allowed_users?.includes(this.$auth?.user?.id + "")) return true;
      if (this.flipmasterSettings.is_enabled) return true;
      return false;
    },
  },
  data: () => ({
    drawer: false,
    mini: false,
  }),
  methods: {
    onResize() {
      if (window.innerWidth > 640 && this.$route.name != "Play") this.drawer = false;
    },
    async logout() {
      await this.$auth.logout();
      location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/";
    },
    numberFormat(amount, format) {
      return numeral(amount).format(format);
    },

    gotoEsports() {
      const url =
        process.env.VUE_APP_SERVER_ENV == "prod"
          ? process.env.VUE_APP_2EZ_URL || "https://2ez.bet"
          : "http://localhost:8000";
      window.open(url);
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  box-shadow: none;
}
</style>
